"use client";
import ProductCard from "@/components/ProductCard";
import { useHits, useInstantSearch } from "react-instantsearch";
import { FormatSubType } from "@/constants/tagular/main";
import SearchResultsLoadingPlaceholder from "@/components/Search/components/SearchHits/ResultsLoading";
import { NoResultsPrograms } from "@/components/Search/components/NoResults";
import { SearchResult } from "@/components/Search/types";
import { convertHitToProductCardProps } from "@/components/Search/utils/convertHitToProductCardProps";
import { PRODUCT_INDEX_EN } from "@/constants/algolia";
import { ProductSummary } from "@/common/productSummary/types";

interface PartnerProgramSearchHitsProps {
  title?: string;
  subtitle?: string;
  location?: string;
  titleComponent?: React.ReactNode;
  indexName?: string;
}

function PartnerProgramSearchHits({
  title = "",
  subtitle = "",
  location = "single-course",
  titleComponent,
  indexName = PRODUCT_INDEX_EN as string,
}: PartnerProgramSearchHitsProps) {
  const { items: hits, results } = useHits<SearchResult | ProductSummary>();
  const { status } = useInstantSearch();

  if (status !== "idle") {
    return <SearchResultsLoadingPlaceholder />;
  } else if (!results?.nbHits) {
    return <NoResultsPrograms titleComponent={titleComponent} />;
  }

  return (
    <div>
      {title ? <h2 className="md:text-3xl mt-0 mb-4">{title}</h2> : null}
      {subtitle ? <p>{subtitle}</p> : null}
      <div className="sm:overflow-x-auto sm:px-10">
        <div className="flex flex-col sm:flex-row sm:flex-nowrap gap-9 sm:gap-4 py-4 items-center">
          {hits.map((hit) => {
            const cardProps = convertHitToProductCardProps(
              hit,
              indexName,
              results,
            );
            return (
              <div
                key={cardProps.objectId}
                className="flex justify-center w-[270px] sm:w-80"
              >
                <ProductCard
                  {...cardProps}
                  location={location}
                  formatSubtype={FormatSubType.HorizontallyStacked}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default PartnerProgramSearchHits;
